module.exports = __webpack_public_path__ + "bb340f1f29e52cc16fef185199e61f4b.MP3";